import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import CMSNav from "./nav"; 
import "./AddProducts.css";

const AddProductForm = () => {
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    slug: "",
    price: "",
    description: "",
    category_id: "",
    stock: "",
    color: "",
    dimensions: "",
    material: "",
    main_image: null,
    discount_percentage: "",
    on_sale: "",
  });

  const token = localStorage.getItem("token");

  // Fetch categories
  useEffect(() => {
    axios
      .get("https://api.goharesadaf.ir/api/admin/categories", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => setCategories(res.data))
      .catch(() => toast.error("Failed to load categories"));
  }, [token]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleCheckboxChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };
  const handleFileChange = (e) => {
    setFormData({ ...formData, main_image: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const fd = new FormData();
      Object.keys(formData).forEach((key) => {
      if (key === "on_sale") {
        fd.append("on_sale", formData.on_sale ? 1 : 0);
      } else {
        fd.append(key, formData[key]);
      }
      });

      await axios.post("https://api.goharesadaf.ir/api/admin/products", fd, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Product added successfully!");
      setFormData({
        title: "",
        slug: "",
        price: "",
        description: "",
        category_id: "",
        stock: "",
        color: "",
        dimensions: "",
        material: "",
        main_image: null,
        discount_percentage: "",
        on_sale: "",
      });
    } catch (err) {
      toast.error(err.response?.data?.message || "Error adding product");
    }
  };

  const renderCategoryOptions = (cats, prefix = "") =>
    cats.map((cat) => (
      <React.Fragment key={cat.id}>
        <option value={cat.id}>
          {prefix}
          {cat.name}
        </option>
        {cat.children && renderCategoryOptions(cat.children, prefix + "--")}
      </React.Fragment>
    ));

  return (
    
    <div className="add-product-page">
      <CMSNav/>  

      <div className="add-product-container">
        <h2 className="form-title">افزودن محصول</h2>
        <form onSubmit={handleSubmit} className="add-product-form">
          <input
            type="text"
            name="title"
            placeholder="نام محصول"
            value={formData.title}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="slug"
            placeholder="اسلاگ محصول (اختیاری)"
            value={formData.slug}
            onChange={handleChange}
          />
          <input
            type="number"
            name="price"
            placeholder="قیمت"
            value={formData.price}
            onChange={handleChange}
          />

          <textarea
            name="description"
            placeholder="توضیحات"
            value={formData.description}
            onChange={handleChange}
          ></textarea>

          <select
            name="category_id"
            value={formData.category_id}
            onChange={handleChange}
            required
          >
            <option value="">دسته‌بندی</option>
            {renderCategoryOptions(categories)}
          </select>

          <input
            type="number"
            name="stock"
            placeholder="تعداد موجود"
            value={formData.stock}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="color"
            placeholder="رنگ"
            value={formData.color}
            onChange={handleChange}
          />

          <input
            type="text"
            name="dimensions"
            placeholder="ابعاد"
            value={formData.dimensions}
            onChange={handleChange}
          />

          <input
            type="text"
            name="material"
            placeholder="جنس"
            value={formData.material}
            onChange={handleChange}
          />

          {/* File Upload for Image */}
          <input
            type="file"
            name="main_image"
            accept="image/*"
            onChange={handleFileChange}
            required
          />
          <div className="form-row">
            <input type="number"
                  name="discount_percentage"
                  min="0" max="100"
                  value={formData.discount_percentage ?? 0}
                  onChange={handleChange}
                  placeholder="درصد تخفیف" />

            <label style={{display: 'inline-flex', alignItems: 'center', gap: 6}}>
              <input type="checkbox"
                    name="on_sale"
                    checked={!!formData.on_sale}
                    onChange={handleCheckboxChange} />
              فعال در فروش ویژه
            </label>
          </div>
          <button type="submit">افزودن</button>
          
        </form>
      </div>

    </div>
  );
};

export default AddProductForm;
